const RULES = {
    requiredObject: (val: Record<string, any>) => !!val || 'Значение должно быть обязательным',

    requiredText: (val: string | null = ''): string | boolean => (val !== '' && val !== null) || 'Обязательно для заполнения',

    requiredArray: (val: number[]) => !!val.length || 'Значение должно быть обязательным'
};


const maskN = (length: number): string => '#'.repeat(length);

const MASK = {
  maskN,
  mask9: maskN(9),
  mask12: maskN(12),
  mask13: maskN(13),
  mask15: maskN(15),
  mask20: maskN(20),
};

export {
    RULES,
    MASK
};